import { useNavigate } from "react-router";
import PageMeta from "../../../components/common/PageMeta";
import PageBreadcrumb from "../../../components/common/PageBreadCrumb";
import NewCademiForm from "../../../components/apps/cademi/NewCademiForm";

export default function NewCademi() {
    const navigate = useNavigate();

    // Função para voltar à página anterior
    const handleGoBack = () => {
        navigate(`/apps/cademi`);
    };

    return (
        <>
            <PageMeta
                title="Sellyo - Nova Integração Cademí"
                description="Criar nova integração Cademí"
            />
            <PageBreadcrumb
                pageTitle="Nova Integração Cademí"
                showBackButton={true}
                onBack={handleGoBack}
            />

            <div className="container mx-auto px-4 md:px-6">
                <NewCademiForm
                    onSuccess={() => {
                        // Redirecionar para a página de edição do produto na aba de webhooks
                        navigate(`/apps/cademi`);
                    }}
                    onError={(error) => {
                        console.error("Erro ao criar integração Cademí:", error);
                    }}
                />
            </div>
        </>
    );
}